"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Context = void 0;
var _react = _interopRequireDefault(require("react"));
var _Modal = _interopRequireDefault(require("./Modal"));
var _useModal2 = require("./useModal");
var _excluded = ["visible"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var Action;
(function (Action) {
  Action["Close"] = "CLOSE";
  Action["Open"] = "OPEN";
})(Action || (Action = {}));
var initialState = {
  body: /*#__PURE__*/_react.default.createElement("div", null),
  footer: [],
  onClose: function onClose() {},
  visible: false
};
var reducer = function reducer(_state, action) {
  switch (action.type) {
    case 1:
    case Action.Open:
      return _objectSpread(_objectSpread({}, action.payload), {}, {
        visible: true
      });
    case 0:
    case Action.Close:
      return initialState;
    default:
      throw new TypeError();
  }
};
var Context = exports.Context = /*#__PURE__*/_react.default.createContext([initialState, function () {}]);
var ModalProvider = function ModalProvider(_ref) {
  var children = _ref.children,
    spritemap = _ref.spritemap;
  var _React$useReducer = _react.default.useReducer(reducer, initialState),
    _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
    _React$useReducer2$ = _React$useReducer2[0],
    visible = _React$useReducer2$.visible,
    otherState = _objectWithoutProperties(_React$useReducer2$, _excluded),
    dispatch = _React$useReducer2[1];
  var _useModal = (0, _useModal2.useModal)({
      onClose: function onClose() {
        return dispatch({
          type: Action.Close
        });
      }
    }),
    observer = _useModal.observer,
    onClose = _useModal.onClose;
  var body = otherState.body,
    center = otherState.center,
    _otherState$footer = otherState.footer,
    footer = _otherState$footer === void 0 ? [] : _otherState$footer,
    header = otherState.header,
    size = otherState.size,
    status = otherState.status,
    url = otherState.url;
  var _footer = _slicedToArray(footer, 3),
    first = _footer[0],
    middle = _footer[1],
    last = _footer[2];
  var state = _objectSpread(_objectSpread({}, otherState), {}, {
    onClose: onClose
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, visible && /*#__PURE__*/_react.default.createElement(_Modal.default, {
    center: center,
    observer: observer,
    size: size,
    spritemap: spritemap,
    status: status
  }, header && /*#__PURE__*/_react.default.createElement(_Modal.default.Header, null, header), /*#__PURE__*/_react.default.createElement(_Modal.default.Body, {
    url: url
  }, body), !!footer.length && /*#__PURE__*/_react.default.createElement(_Modal.default.Footer, {
    first: first,
    last: last,
    middle: middle
  })), /*#__PURE__*/_react.default.createElement(Context.Provider, {
    value: [state, dispatch]
  }, children));
};
var _default = exports.default = ModalProvider;